module.exports = __webpack_public_path__ + "static/img/RWDA965-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RWDA965-G_1.png
// module id = xie8
// module chunks = 0